import React from "react";
import { Button, InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import PayrollLayoutsFormPresenter from "./PayrollLayoutsFormPresenter";
import FormFactory from "../../../../components/FormFactory";
import PayrollHeader from "../../../../components/PayrollHeader/PayrollHeader";
import PayrollFooter from "../../../../components/PayrollFooter/PayrollFooter";

class PayrollLayoutsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      objectID: "",
      object: {},
    };
    this.presenter = new PayrollLayoutsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "payroll_layouts";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  setObject(object) {
    this.setState({ object });
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  onHeaderChange = (headerData) => {
    this.presenter.onChange(headerData, "header");
  };

  onFooterChange = (footerData) => {
    this.presenter.onChange(footerData, "footer");
  };

  async handleSubmit() {}

  render() {
    const { object } = this.state;

    console.log("object", object);

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
      <div className="overflow-auto mt-5">
        <div className="h-100">
          <div className="p-3 p-lg-4">
            <h1 className="fw-bold mt-3 text-capitalize">
              {(schema.label || this.getCollectionName()) + " Details"}
            </h1>
            <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.save();
                }}
              >
                  <div className="row g-3">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.presenter.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <FormFactory
                      schema={schema}
                      object={object}
                      // disabled={true}
                      onChange={this.onChange.bind(this)}
                    />
                  )}
                </div>
                 {/* Payroll Header Component */}
                 <div className="mb-4 mt-4">
                   <PayrollHeader
                     header={object.header}
                     onChange={this.onHeaderChange}
                   />
                 </div>

                 {/* Payroll Footer Component */}
                 <div className="mb-4 mt-4">
                   <PayrollFooter
                     footer={object.footer}
                     onChange={this.onFooterChange}
                   />
                 </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={this.onClickBack.bind(this)}
                  >
                    GO BACK
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary fs-sm ms-2 me-3"
                  >
                    <i className="bi bi-file-earmark-check me-2"></i>
                    {label}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
    );
  }
}

export default withRouter(PayrollLayoutsFormPage);
